import { Injectable } from '@angular/core';
import SecureStorage from 'secure-web-storage';
import { environment } from '../environments/environment';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
    

public secureStorage = new SecureStorage(localStorage, {
hash: function hash(key:any): any {
    key = CryptoJS.SHA256(key).toString();
    return key.toString();
},
// Encrypt the localstorage data
encrypt: function encrypt(data:any) {
    data = CryptoJS.AES.encrypt(data, environment.leskey);
    data = data.toString();
    return data;
},
// Decrypt the encrypted data
decrypt: function decrypt(data:any) {
    data = CryptoJS.AES.decrypt(data, environment.leskey);
    data = data.toString(CryptoJS.enc.Utf8);
    return data;
}
});
}